import dayjs from "dayjs";
export default function formatDate(fullDate) {
  return dayjs(fullDate).format("YYYY-MM-DD");
}
